import { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'

interface AuthContextType {
    isLoggedIn: boolean
    login: (token: string) => void
    logout: () => void
}

const AuthContext = createContext<AuthContextType | null>(null)

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [token, setToken] = useState(localStorage.getItem('token') ?? '')

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            setIsLoggedIn(true)
        } else {
            axios.defaults.headers.common['Authorization'] = ''
            setIsLoggedIn(false)
        }
    }, [token])
    
    const login = (token: string) => {
        setToken(token)
        setIsLoggedIn(true)
        localStorage.setItem('token', token)
    }

    const logout = () => {
        setToken('')
        setIsLoggedIn(false)
        localStorage.removeItem('token')
    }


    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuthContext = () => {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider')
    }
    return context
}
